<script setup lang="ts">
import type { InputPrimaryEvent } from '@shared/ui/fields'
import type { RubricEditorProps } from '../../../../model/assessments/rubric-editors.hook'

import { InputPrimary } from '@shared/ui/fields'

import { useRubricEditor } from '../../../../model/assessments/rubric-editors.hook'
import RubricLevelList from './RubricLevelList.vue'
import StandardSelect from '../StandardSelect.vue'

defineOptions({
  name: 'RubricEditor',
})

const props = defineProps<RubricEditorProps>()

const {
  refRubric,
  refName,
  setName,
} = useRubricEditor({ rubricId: () => props.rubricId })
</script>

<template>
  <div
    v-if="refRubric"
    class="rubric-editor"
  >
    <!-- The name is the card's heading AND its field — one row, not a heading above a labelled
         input, which is what the card looked like before. The catalog fills `#actions` with the
         usage count and the remove button so those share the row too. -->
    <div class="rubric-editor__head">
      <InputPrimary
        name="rubric-name"
        :value="refName"
        placeholder="Rubric name — e.g. Shows the reasoning"
        class="rubric-editor__name"
        @input="(event: InputPrimaryEvent) => setName(String(event.value))"
      />
      <slot name="actions" />
    </div>

    <!-- The rubric's OWN standards (codes), which is why B12.1.2's removal of this field was
         reversed: a question may carry several rubrics reviewed against different standards, so
         this is no longer a copy of the activity's array. An auto-graded question, which has no
         rubric, tags the activity instead. -->
    <StandardSelect :owner="{ rubricId }" />

    <!-- No dispatch: there is one rubric type (decision B10), so the levels form is the rest of
         this card rather than one of two branches. -->
    <RubricLevelList :rubric-id="rubricId" />
  </div>
</template>

<style scoped lang="scss" src="./RubricEditor.scss" />
